import { Pipe, PipeTransform } from '@angular/core';
import { PlatformLocation } from '@angular/common';

@Pipe({ name: 'assetspipe' })
export class AssetsPipe implements PipeTransform {
    baseUrl: string;

    constructor(platformLocation: PlatformLocation) {
        this.baseUrl = platformLocation.getBaseHrefFromDOM();
    }

    transform(value: string): string {
        const newval: string = this.baseUrl + value;
        return newval;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/pipes/assets-pipe.ts